



























































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import moment from 'moment'
import store from '@/store/index'
import { SO_FAR, TOKEN } from '@/store/mutation-types'
import { Base64 } from 'js-base64'
import Task from '@/web-task'
import { initOrderDetail } from '@/web-task/utils/order'
import { rsappPath } from '@/api/url'

@Component({
	name: 'snapshot',
})
export default class Screenshots extends Vue {
	private order: any = {}
	private injured: any = {}
	private work: any = {}
	private livingInfoList: any = {}
	private injuredInfo: any = {}
	private familyDto: any = {}
	private caregiversDto: any = {}
	private visitorSignatureInfo: any = {}
	private injuredSignatureInfo: any = {}
	private show: any = ''
	private task: any = ''
	private rsappPath: any = rsappPath

	private get token() {
		return Base64.encode(this.$route.params.token)
	}

	private mounted() {
		window.addEventListener(
			'message',
			(e: any) => {
				const data = e.data
				for (const item in data) {
					if (['socialRelations', 'signImage', 'basicInfo'].includes(item)) {
						;(document as any).getElementById(item).style.height =
							data[item] + 'px'
					}
				}
			},
			false
		)
	}

	private created() {
		const token = this.$route.params.token
		const orderId = this.$route.params.orderId
		if (token && orderId) {
			this.$ss.set(TOKEN, token)
			this.getDetail()
		}
	}

	private getDetail() {
		return TaskApi.getTaskDetailForSnapshot(this.$route.params.orderId).then(
			(data: any) => {
				if (data.code === 200) {
					this.order = data.data.order
					this.task = new Task({
						propsData: {
							order: this.order,
						},
					})
					this.order.operationTime = moment(this.order.operationTime).format(
						'YYYY-MM-DD'
					)
				}
			}
		)
	}
}
